import { render, staticRenderFns } from "./DetectedTransactionsTable.vue?vue&type=template&id=2af3d69e&scoped=true"
import script from "./DetectedTransactionsTable.vue?vue&type=script&lang=js"
export * from "./DetectedTransactionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af3d69e",
  null
  
)

export default component.exports